import React from 'react'
import { isLocal } from '../../../utility'
import { convertToPascalCase } from '../../utilities/utilities.js'
import { getTitle } from './blogFilterDeepLinksUtilities'
import { isInstitutional } from '../../../../global/authentication/authentication-manager.js'

function BlogFilterDeepLinks({ data = [] }) {
  const getLatestInsights = (topic) => {
    let insightsHref = ''

    if (isInstitutional()) {
      insightsHref = isLocal()
        ? `/cti-site/cti-institutional/insights/latest-insights?topic=${topic}`
        : `/institutional/insights/latest-insights?topic=${topic}`
    } else {
      insightsHref = isLocal()
        ? `/cti-site/blogspa?topic=${topic}`
        : `/insights/latest-insights?topic=${topic}`
    }
    return insightsHref
  }

  return (
    <div className="BlogFilterDeepLinks">
      {data.map((item) => (
        <div
          className="u-flex u-flexAlignItemsCenter u-sm-marginBottom4gu"
          key={item?.key}
        >
          <div className="u-flex">
            <div className="u-textSecondary u-textBold">
              {getTitle(item?.key)}:
            </div>
            <div className="u-flex u-marginLeft2gu u-textColorBrandLight u-md-textSizeMsrm1 u-textItalic u-textCapitalize">
              {item?.categories.map((category, index) => (
                <React.Fragment key={category?.key}>
                  {index > 0 && <span>,&nbsp;</span>}
                  <a
                    className="u-flex u-textItalic"
                    href={getLatestInsights(category?.key)}
                  >
                    {convertToPascalCase(category?.key?.replaceAll('-', ' '))}
                  </a>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export { BlogFilterDeepLinks }
